.editedLozengeWrapper {
	display: inline-block;
	margin-left: var(--jpo-common-base-spacing);
}

.viewsListSkeleton {
	height: 165px;
	min-width: 300px;
}

.viewsList {
	overflow-x: hidden;
	overflow-y: auto;
	/* This removes scrollbars that appear from overlapped elements in IE11 */
	-ms-overflow-style: auto;
	max-height: 180px; /* Enough to show 4.5 views */
	min-width: 300px;
}

@media (min-height: 650px) {
	.viewsList {
		max-height: 260px; /* Enough to show 6.5 views */
	}
}

@media (min-height: 750px) {
	.viewsList {
		max-height: 300px; /* Enough to show 7.5 views */
	}
}

@media (min-height: 820px) {
	.viewsList {
		max-height: 340px; /* Enough to show 8.5 views */
	}
}

.activeMenuItem {
	background: var(--ds-background-neutral, var(--adg3-color-N20));
}

.currentLabelWrapper {
	color: var(--ds-text-subtlest, var(--adg3-color-N300));
	font-size: 12px;
	margin-left: var(--jpo-common-base-spacing);
}

.viewSwitcherMenuHeader {
	color: var(--ds-text-subtlest, var(--adg3-color-N200));
	font-weight: 500;
	padding: var(--jpo-common-base-spacing) calc(2 * var(--jpo-common-base-spacing));
}

.manageViewsItem {
	border-top: 1px solid var(--ds-border, var(--adg3-color-N40A));
	border-bottom: 1px solid var(--ds-border, var(--adg3-color-N40A));
}

.viewName {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.view {
	align-items: center;
	display: flex;
}

.viewTrigger {
	align-items: center;
	display: flex;

	& .view {
		max-width: 175px;
	}

	&.withScenarios {
		& .view {
			max-width: 100px;
		}
	}

	&.isReadOnly {
		& .view {
			max-width: 120px;
		}

		&.withScenarios {
			& .view {
				max-width: 70px;
			}
		}
	}
}

@media (min-width: 1280px) {
	.viewTrigger {
		& .view {
			max-width: 240px;
		}

		&.withScenarios {
			& .view {
				max-width: 160px;
			}
		}

		&.isReadOnly {
			& .view {
				max-width: 180px;
			}

			&.withScenarios {
				& .view {
					max-width: 125px;
				}
			}
		}
	}
}

@media (min-width: 1440px) {
	.viewTrigger {
		& .view {
			max-width: 280px;
		}

		&.withScenarios {
			& .view {
				max-width: 195px;
			}
		}

		&.isReadOnly {
			& .view {
				max-width: 215px;
			}

			&.withScenarios {
				& .view {
					max-width: 155px;
				}
			}
		}
	}
}

@media (min-width: 1536px) {
	.viewTrigger {
		& .view {
			max-width: 305px;
		}

		&.withScenarios {
			& .view {
				max-width: 215px;
			}
		}

		&.isReadOnly {
			& .view {
				max-width: 235px;
			}

			&.withScenarios {
				& .view {
					max-width: 175px;
				}
			}
		}
	}
}

@media (min-width: 1680px) {
	.viewTrigger {
		& .view {
			max-width: 340px;
		}

		&.withScenarios {
			& .view {
				max-width: 245px;
			}
		}

		&.isReadOnly {
			& .view {
				max-width: 270px;
			}

			&.withScenarios {
				& .view {
					max-width: 205px;
				}
			}
		}
	}
}

@media (min-width: 1920px) {
	.viewTrigger {
		& .view {
			max-width: 400px;
		}

		&.withScenarios {
			& .view {
				max-width: 305px;
			}
		}

		&.isReadOnly {
			& .view {
				max-width: 330px;
			}

			&.withScenarios {
				& .view {
					max-width: 260px;
				}
			}
		}
	}
}
